// extracted by mini-css-extract-plugin
export default {"container":"Ship_container","nationIcon":"Ship_nationIcon","classIcon":"Ship_classIcon","title":"Ship_title","gold":"Ship_gold","legendaryStarIcon":"Ship_legendaryStarIcon"};